<!-- <div [@routeAnimations]="prepareRoute(outlet)">
    <router-outlet #outlet="outlet"></router-outlet>
</div> -->

<router-outlet></router-outlet>